import React from 'react';
import { Form } from 'semantic-ui-react';

import Radio, { RadioGroupProps } from 'src/components/custom/Radio';

export type Props = {
  label?: string;
  id?: string;
  value?: string | number | (string | number)[];
  error?: string;
  name?: string;
  extra?: React.ReactNode;
} & RadioGroupProps;

const RadioGroupField: React.FC<Props> = (props) => {
  const { error, label, extra, ...rest } = props;

  return (
    <Form.Field error={!!error}>
      <label>{label}</label>

      <Radio.Group {...rest} />
      {extra && <div>{extra}</div>}
      {error && <div className="ui pointing above prompt label">{error}</div>}
    </Form.Field>
  );
};

export default RadioGroupField;
